import React, { PureComponent } from 'react';
// import { provideHooks } from 'redial';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { getSavedPrescription } from '../../../actionCreators/success';
import BootstrapSuccessError from './BootstrapSuccessError';
import './Prescriptions.scss';
import PowersTypes from '../Success/PowersTypes';
import BlankLoader from '../Common/BlankLoader';

// const hooks = {
//     defer: ({ store: { dispatch } }) => {
//         dispatch(getSavedPrescription());
//     }
// }

class Prescriptions extends PureComponent {
  componentDidMount() {
    this.props.getSavedPrescription();
    if (window.dtm.LenskartRewamp && window.dtm.LenskartRewamp.myaccount) {
      window.dtm.LenskartRewamp.myaccount.OnLoad({
        pagename: 'my prescriptions',
        satellite: 'account',
        subSection1: 'my prescriptions',
      });
    }
  }
  render() {
    const { loading, savedPrescription, dataLocale } = this.props;
    const {
      MY_SAVED_PRESCRIPTIONS,
      YOU_DO_NOT_ANY_PRESCRIPTIONS,
      NAME,
      POWER_TYPE,
      NOTES,
      CREATED,
      MY_PRESCRIPTIONS,
    } = dataLocale;
    return (
      <React.Fragment>
        <Helmet title={MY_PRESCRIPTIONS} />
        <h2 className="title margin-b10">{MY_SAVED_PRESCRIPTIONS}</h2>
        {!loading &&
          savedPrescription &&
          savedPrescription.result &&
          savedPrescription.result.length === 0 && (
            <BootstrapSuccessError
              message={YOU_DO_NOT_ANY_PRESCRIPTIONS}
              timeout="false"
              type="warning"
            />
          )}
        {loading && <BlankLoader data-testid="blankLoader" imageStyle={{}} style={{}} />}
        {!loading && savedPrescription && Boolean(savedPrescription.result) && (
          <div className="prescription-container margin-t10 display-flex flex-wrap">
            {savedPrescription.result.map((power, index) => {
              return (
                <div key={index} className="prescription-item" data-testid="prescription-item">
                  <div className="my-prescription">
                    <h3 className="pres-name">
                      <span>{NAME}: </span>
                      <span>{power.userName}</span>
                    </h3>
                    <p className="pres-name">
                      <span>{POWER_TYPE}: </span>
                      <span>{power.powerType && power.powerType.replace('_', ' ')}</span>
                    </p>
                    {power.notes && (
                      <p className="pres-name">
                        {NOTES}: {power.notes}
                      </p>
                    )}
                    {Boolean(power.recordedAt > 0) && (
                      <span className="pres-date" data-testid="recordedAt">
                        {CREATED} {new Date(power.recordedAt).toString().slice(0, 15)}
                      </span>
                    )}
                  </div>
                  <PowersTypes selectedPower={power} />
                </div>
              );
            })}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  savedPrescription: state.success.savedPrescription,
  loading: state.success.loading,
  dataLocale: state.locale,
});

function mapDispatchToProps(dispatch) {
  return {
    getSavedPrescription: () => dispatch(getSavedPrescription()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Prescriptions);
